// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__-4cmu","name":"Header_name__36bAW","birthday":"Header_birthday__3QWnc","skeleton":"Header_skeleton__1hmlc"};